import { type FC } from "react"
import { Link } from "react-router"

import { toPriceString } from "@forento/shared/utilities/currency"

import Card, {
	CardHeader,
	Cards,
	CardSticker,
	CardText,
	CardThumbnail,
	CardThumbnailSticker,
	CardTitle,
} from "~/themes/school/components/Card"
import Layout from "~/themes/school/components/Layout"
import { PageTitle } from "~/themes/school/components/PageHeader"
import PartialLoadingPage from "~/themes/school/components/PartialLoadingPage"
import { useTranslation } from "~/translations"
import routes from "~/utilities/routes"
import { query } from "~/utilities/trpc"

const BundlesPage: FC = () => {
	const t = useTranslation()

	const { data, error } = query.bundle.listPersonalized.useQuery()

	return (
		<Layout>
			<PageTitle>{t("bundle.title")}</PageTitle>
			{error ? (
				<p>{t("failedToLoad")}</p>
			) : !data ? (
				<PartialLoadingPage />
			) : (
				<Cards>
					{data.map(card => (
						<Card key={card.id} as={Link} to={routes.bundle.detail(card.id)}>
							<CardHeader>
								<CardTitle>{card.name}</CardTitle>
								<CardSticker>
									{t("bundle.discount", {
										discount:
											card.contentPrice > 0
												? Math.floor((1 - card.price.amount / card.contentPrice) * 100)
												: 0,
									})}
								</CardSticker>
							</CardHeader>
							<CardThumbnail
								filePath={card.thumbnailUrl}
								sticker={<CardThumbnailSticker>{toPriceString(card.price)}</CardThumbnailSticker>}
							/>
							<CardText>{card.shortDescription}</CardText>
						</Card>
					))}
				</Cards>
			)}
		</Layout>
	)
}

export default BundlesPage
